import { Component, Input } from 'angular-ts-decorators';
import {
  faCheck,
  faTimes,
  faStethoscope,
} from '@fortawesome/pro-solid-svg-icons';
import { DataFeedAws } from '@shared/app/scripts/services/data-feed-aws';

/**
 * A component to parse the SKU Feed and show information about the feed health.
 *
 * # Example
 * <pre>
 *   <sku-feed-check key="uuid"></sku-feed-check>
 * </pre>
 */
@Component({
  selector: 'skuFeedCheck',
  template: require('./sku-feed-check.html').default,
})
export class SkuFeedCheckComponent {
  @Input() key: string;
  errorMessage: string;
  jsonParseError: string;
  skuFeedPasses: boolean;
  totalSkus: number;
  faCheck = faCheck;
  faTimes = faTimes;
  faStethoscope = faStethoscope;

  constructor(
    private dataFeedAws: DataFeedAws,
    private uuid,
  ) {
    'ngInject';
  }

  private parseJson(data) {
    if (angular.isObject(data)) {
      return true;
    }
    try {
      JSON.parse(data);
      return true;
    } catch (e) {
      if (angular.isString(data) && e.message.indexOf('at position') !== -1) {
        let r: RegExp = new RegExp('[0-9].*$');
        let position: number = Number(r.exec(e.message));
        this.jsonParseError = data.substr(position - 500, 1000).toString();
      } else {
        this.jsonParseError = e.toString();
      }

      return false;
    }
  }

  checkSkuFeed() {
    return this.dataFeedAws
      .get(this.uuid.v4(), this.key)
      .then((data) => {
        this.skuFeedPasses = this.parseJson(data);
        this.totalSkus = angular.isArray(data) ? data.length : 0;
        return data;
      })
      .catch((error) => {
        // Check the error object
        if (angular.isString(error)) {
          this.parseJson(error);
        } else if (angular.isObject(error)) {
          if (error.status === 403 || error.status === 404) {
            this.errorMessage = 'Sku Feed is missing! Has it been generated?';
          } else {
            this.errorMessage = `Status: ${error.status} ${error.statusText}`;
          }
        } else {
          this.errorMessage = 'Unknown error with Sku Feed';
        }
        this.skuFeedPasses = false;
      });
  }
}
